import { FormattedMessage} from 'react-intl';
import React, {Component, useEffect, useState} from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';

import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import { Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import MyUploader from "../../elements/Upload";
import FilesTable from "../Assesment/table";
import ModalExample from "./popup";
import ModalExample3 from "./popup2";
import ModalExample4 from "./popupedit";
//import ModalExample2 from "../../elements/PopupWindow";
import UserTable from './table';
import set from 'core-js/es6/set';


const messages = {
  htmlHeader: {
    id: 'translation.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Translation'
  },
  headerTitle: "MY DATA FACTORY",
  headerSubTitle: "Create/update a data factory"

};

let openModal = ()=>{};
let confirmation =()=>{};
const Createdatafactory = (props) => {
  console.log(props.match.params.dfid);
   useEffect(() => {
    //if(props.role.includes('TRANSLATION_LEAD') || props.role.includes('DATA_ENGINEER')){
   if(true){
    // setRepo("test");
    // setSrclang("3.0");
    // setHive("1.2");
    // setTargetLanguage('Python');
    console.log("userEffect");
    if(props.match.params.dfid != undefined){


    //  changeRepo();
         // setCustomerdfListcopy(props.customerdfList);
            console.log(props.customerdfList);
            console.log(customerdfListcopy);

            const newItemsdflist = [...props.customerdfList];

         //   props.getdfListCopy(newItemsdflist,setCustomerdfListcopy);
           // console.log(newItemsdflist);



             // setCustomerdfListcopy(newItemsdflist);

            //customerdfListcopy = [...props.customerdfList];
            console.log(customerdfListcopy);

          // {props.customerdfList.map(item => {
           // {customerdfListcopy.map(item => {
        {newItemsdflist.map(item => {
            console.log(item);
                  if (item.dfid == props.match.params.dfid){
                    console.log("new item");
                      setRepo(item['reponame']);
                       setSrclang(item['srclang']);
                      // setHive(item['hive']);
                      console.log(item['jdbclist']);
                     // window.location.reload();
                    //  setJdbclistcopyy(jdbclistcopyy => [...jdbclistcopyy, item['jdbclist']]);
                    setJdbclistcopyy(item['jdbclist']);

                      }

               }
          )
            }
        }
        console.log("in jdbclistcopyy");
        console.log(jdbclistcopyy);
        props.getUsersList(props.username,setUserlistcopyy);
    //  setJdbclistcopyy(jdbclistcopyy =>[... {"name":"test","jdbcdriver":"test","dbversion":"test","host":"default",
    //  "dbname":"test","dbusername":"test","dbpassword":"test"}]);

     console.log(jdbclistcopyy);
      // props.getCustomers();
      // props.resetCustomersPrjList();
      // props.resetStagingPrjList();
    }else{
      console.log("in else");
      props.customersPrjList('Translation', props.customerid);
    }
  //window.location.reload();

   //sessionStorage.setItem('firstimeselectedcus','');
  }, []);


  const [showEditor, setShowEditor] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [repo, setRepo] = useState("");
  const [repos, setRepos] = useState([{value:"SS", checked: false},{value:"BB", checked: false}]);
  const [customer, setCustomer] = useState("");
  const [stagingrepo, setStagingrepo] = useState("");
  const [stagingprojectList, setStagingprojectList] = useState("");
  const [refId, setRefId] = useState("");
  const [type, setType] = useState("");
  const [srclang, setSrclang] = useState("");
  const [hive, setHive] = useState("");
  const [hadoop, setHadoop] = useState("");
  const [dfid, setDfid] = useState("");
  const[edit,setEdit] = useState(true);
  const[index, setIndex] = useState();
 // const [targetLanguage, setTargetLanguage] = useState(["Python","Scala"]);
 const [targetLanguage, setTargetLanguage] = useState("");
  // const [srlang, setSrlang] = useState("");
  const [description, setDescription] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [uploadcontent, setUploadcontent] = useState("");
  const [disableUploadBack, setDisableUploadBack] = useState("");
  const [disableupload, setDisableupload] = useState(false);
  const jobType = "Translation";
  const [delUser, setDelUser] = useState("");
  const [delEmail, setdDlEmail] = useState("");
  const [status, setStatus] = useState("");
  //const [selectItem, setSelectItem] = useState("{delUser: 'test',status: 'test',delEmail: value.'test@hotm.com'}");

  const [jdbcname, setJdbcname] = useState("");
  const [dbversion, setDbversion] = useState("");
  const [jdbcdriver, setJdbcdriver] = useState("");
  const [port, setPort] = useState("");
  const [dbname, setDbname] = useState("");
  const [dbusername, setDbusername] = useState("");
  const [dbpassword, setDbpassword] = useState("");
  const [dbpasswordconfirm, setDbpasswordconnfirm] = useState("");
  const [jdbcdriverList, setJdbcdriverList] = useState(["com.mysql.jdbc.Driver","com.microsoft.sqlserver.jdbc.SQLServerDriver"]);


 const [userlistcopyy, setUserlistcopyy] = useState([]);
 const [jdbclistcopyy, setJdbclistcopyy] = useState([]);
 const [customerdfList, setCustomerdfList] = useState([]);
 const [customerdfListcopy, setCustomerdfListcopy] = useState([]);

 //let openModal = ()=>{};
 var sessionjdbc=[];
//  {"name":"test","jdbcdriver":"test","dbversion":"test","host":"default",
//  "dbname":"test","dbusername":"test","dbpassword":"test"}

const deleteJdbc = ()=>{
  console.log(index);
  const list = jdbclistcopyy.filter((item, j) => index !== j);
  console.log(list);
  setJdbclistcopyy(list);
  setEdit(true);



}
  const selectItem = (value,i)=>{
  //alert(i);
    console.log(i);
    setIndex(i);
    //this.setState({delUser: value.username,status: value.status,delEmail: value.email})
    // setDelUser(value.username);
    // setdDlEmail(value.email);
    // setStatus(value.status);
    setJdbcname(value.name);
    setJdbcdriver(value.jdbcdriver);
    setDbversion(value.dbversion);
    setDbname(value.dbname);
    setDbusername(value.dbusername);
    setEdit(false);
    //setDbusername(value.setDbusername);
  };

  const cleanback  = ()=>{
    setJdbcname("");
    setJdbcdriver("");
    setPort("");
    setDbname("");
    setDbversion("");
    setDbusername("");
    setDbpassword("");
    setDbpasswordconnfirm("");


  }
  const repoCallback = ()=>{
    if (dbpasswordconfirm !== dbpassword){
             return openModal();
    }
    

    let temp = userlistcopyy;

    // let newElement=({"id":88888,"status":"APPROVED","ipAddress":null,"can_create_group":"false","userActivityId":null,
    // "loginAttempts":0,"name":"null null","skip_confirmation":false,"token":null,"grant_type":null,"guid":null,
    // "deviceInfo":null,"groupId":"34","gitlab_id":"96","firstName":"test","lastName":"test","username":"ayutest002","email":"ayutest002@nextpathway.com","password":null,"role":null,"permission":"view,edit","creationDateTime":"2020","expirationDateTime":"2375-03-26T14:30:52.166","phoneNumber":"","newPassword":null,"customerid":null,"adminUsername":null})


    let newElement=({
    "name":"null null","guid":null,
    "groupId":"34","gitlab_id":"96","firstName":"test","lastName":"test","username":"ayutest888",
    "email":"ayutest002@nextpathway.com","password":null,"role":null,"permission":"view,edit",
    "creationDateTime":"2020","expirationDateTime":"2375-03-26T14:30:52.166","phoneNumber":"",
    "newPassword":null,"customerid":null,"adminUsername":null})


  //  let newElement=({"name":"test","jdbcdriver":"test","dbversion":"test","host":"default",
  //    "dbname":"test","dbusername":"test","dbpassword":"test"})

    console.log(userlistcopyy);

    //setUserlistcopyy(userlistcopyy => [...userlistcopyy, newElement]);




//  for jdbclist
console.log(jdbclistcopyy);

let newElementJdbc=({"name":jdbcname,"jdbcdriver":jdbcdriver,"dbversion":dbversion,"host":"default"+':'+port,
"dbname":dbname,"dbusername":dbusername,"dbpasswordshow":'********',"dbpassword":dbpassword});
console.log(newElementJdbc);
//sessionStorage.setItem('jdbclistcopyy',sessionjdbc.push(newElementJdbc));


setJdbclistcopyy(jdbclistcopyy => [...jdbclistcopyy, newElementJdbc]);
console.log(jdbclistcopyy);
//end of jdbclist

//sessionjdbc.push(newElementJdbc);
  }


  const repoCallbackEdit = ()=>{
    console.log(dbusername);
    //setJdbclistcopyy(jdbclistcopyy);
   const newItems = [...jdbclistcopyy];
   // newItems[0]['dbusername'] = '99999';
//this.setState({ items:newItems });
   // setDbusername(dbusername)
     //jdbclistcopyy['dbusername'] = dbusername;
     //setJdbclistcopyy(jdbclistcopyy);
     //setJdbclistcopyy(newItems);
     console.log(newItems);
     newItems.map((item,inde) => {
 
     if(inde==index){
       item['name'] = jdbcname;
       item['jdbcdriver'] = jdbcdriver;
      item['dbversion'] = dbversion;
      item['port'] = port;
      item['host'] = 'default'+':'+port;
      item['dbusername'] = dbusername;
      item['dbname'] = dbname;
      item['dbpassword'] = dbpassword;
     }
 
     });
 
   // insertJdbcListlo(newItems);
   console.log(newItems);
       setJdbclistcopyy(newItems);
     console.log(newItems);
  }

  const setReposs = (e)=>{
       console.log(e);
       setRepos(e);
  }

  const selectCus = (e)=>{
    setCustomer(e.target.value);
    props.customersPrjList("Translation",e.target.value);
  };

  const showMessageTrue = (e) => {
    setShowMessage(true);
    setRefId(e.value.data);
  };

  const getStagingRepo = (jobtype,_repo)=>{
    setStagingrepo("");
    setRepo(_repo);
    props.getinfobyreponameforaccessment(_repo,customer,jobType,updateSrcTar);
    props.getStagingPrjList(jobtype,_repo,customer);
  }

  const updateSrcTar = (e)=>{
    console.log("test1");
    setTargetLanguage(e.value.data.tgtlang);
    setSrclang(e.value.data.srclang);
    setDescription(e.value.data.description);
  }

  const showNPupload =(type)=>{
    messages.headerSubTitle = type === "upload" ? "Upload source code" : "Update source code";
    setUploadType(type);
    setShowUpload(true);
    const prj = type === 'upload' ? `${repo}_${Date.now()}` : stagingrepo;
    setProjectName(prj);
  }

  const showNPuploadFlase =()=>{
    messages.headerSubTitle = 'Commercial code translation request';
    // getStagingRepo(jobType,repo);
    props.getStagingPrjList(jobType,repo,customer);
    setShowUpload(false);
    setDisableupload(false);
  }
  const uploadstatus = null;

  const showUploadFalse = ()=>{
    props.customersPrjList('Translation', props.customerid);
    setShowUpload(false);
    setDisableupload(false);
    messages.headerSubTitle = 'Commercial code translation request';
  }

  const showUploadTrue = (type)=>{
    messages.headerSubTitle = type === "upload" ? "Upload source code" : "Update source code";
    setUploadType(type);
    if(type === "upload"){
      setShowUpload(true);
      setProjectName("");
    }else{
      setShowUpload(true);
      setProjectName(repo);
    }
  }

  const gotoFileList = ()=>{
    if(srclang !== "" && targetLanguage !== "" && repo !== ""
      && srclang !== null && targetLanguage !== null && repo !== null
    ){
      getFilesList();
    }
  }

  const getFilesList = ()=>{
    setShowFiles(true);
    props.getfilesList(repo,props.customerid);
  }

 // const changeRepo = (e)=>{
    const changeRepo = ()=>{
    //setRepo(e.target.value)
  //  props.getinfobyreponameforaccessment(e.target.value,props.customerid,jobType,updateSrcTar);
    props.getinfobyreponameforaccessment('2-Testing-Data_Assessment_Orig','mock_customer_identifier','Assessment',updateSrcTar);


  }

  const _setDisableUploadBack = (val)=>{
    setDisableUploadBack(val);
  }

  const setPrjName = (name)=>{
    setProjectName(name);
  }

  const submitRequest = ()=>{
    confirmation();
  }

  const submitRequest1 = ()=>{
    confirmation();
  }

  const checkexisting =(e)=>{
    //alert(e.target.value);
   // openModal();
   if(e.target.value.trim() !==""){
     props.checkdfname(repo,props.match.params.customerid);
   }
  }

  const confirmationSubmit = ()=>{
    props.userRequest(
      props.username,
      repo,
      srclang,
      targetLanguage,
      description,
      jobType,
      props.customerid,
      showMessageTrue
    );
  }
  const confirmationText = "You are about to Submit the uploaded code for commercial translation.  <br /><br />" +
    "Your request will be reviewed and approved by your Administrator.<br /><br />" +
    "Click SUBMIT to send your request to your Administrator.<br />"


  const checkuploadinlist = (prj,type)=>{
    if(type !== 'internal_assessment' && type !== 'internal_translation'){
      props.customersPrjList('Translation', props.customerid);
      // if(props.customerprojectList.includes(prj)){
        setRepo(prj);
      // }
      // console.log(props);
      // console.log(r.customerprojectList.includes(prj));
      // return props.customerprojectList.includes(prj);
      return true;
    }else{
      props.getStagingPrjList(jobType,repo,customer);
      // if(props.stagingprojectList.includes(prj)){
        setStagingrepo(prj);
        console.log(stagingrepo);
        console.log(prj);
      // }

      // return props.stagingprojectList.includes(prj);
      return true;
    }
  }

  

  //if(props.role.includes('TRANSLATION_LEAD') || props.role.includes('DATA_ENGINEER')){
    if(true){
      console.log(showMessage);

    return (
      <div className="preview page">
        <Helmet>
          CREATE DATA FACTORY - FUSE
        </Helmet>
        <Header
          title={messages.headerTitle}
          subtitle={messages.headerSubTitle}
          icon="preview"
          locale={props.locale}
          status = {props.status}
        />

<ModalExample3
          hasTitle
          warning
          warningText="Error"
          className='sm'
          reset={() => {}}
          setClick={click => openModal = click}  
          content="Re-enter password is not matched."
        />


        <div className="main">
          <div
            className="panel"
            style={{
              width: '90%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >

            {!showMessage && (
              <div>
                {showUpload ? (
                  <div className="form">
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="assessment.projectName"
                        defaultMessage="Project Name"
                      />
                    </label>
                    <Control.text
                      model=".projectName"
                      value={projectName}
                      placeholder={uploadType==='upload' ?"same as zip file name" : ""}
                      disabled
                    />
                    <br />
                    <br />
                    <br />
                    {MyUploader(projectName,props.username,uploadType, "internal_translation",repo,customer,
                      uploadcontent,setUploadcontent,_setDisableUploadBack,setPrjName,checkuploadinlist,disableUploadBack,
                      disableupload,setDisableupload
                    )}
                    <br />
                    <br />
                    <br />

                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={showNPuploadFlase}
                      disabled={disableUploadBack}
                    >
                      back
                    </button>
                  </div>
                ) : null}

                {!showUpload ? (
                  <LocalForm
                    className="form"
                    onSubmit={() =>
                      props.clickSubmitHandler(
                        props.match.params.customerid,
                       // props.customerid,
                        props.username,                    
                        0,
                        type,
                        repo,
                        srclang,
                        targetLanguage,
                        hive,
                        hadoop,
                       // userlistcopyy,
                        jdbclistcopyy,
                        // description,
                        // jobType,
                        // stagingrepo,
                        // customer,
                        showMessageTrue
                      )
                    }
                    initialState={
                      { reponame: 'test' }
                      //reponame = ''
                      // project
                      //   ? {
                      //       projectName: project.projectName,
                      //       engagementId: project.engagementId,
                      //       sourceLanguage: project.sourceLanguage,
                      //       targetLanguage: project.targetLanguage,
                      //       workspace: Array.isArray(project.workspace)
                      //         ? project.workspace.join('\n')
                      //         : null
                      //     }
                      //   : {}
                    }


                  >
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >



                 <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="data.factory.name"
                            defaultMessage="Data Factory Name: "
                          />
                        </label>

                        <Control.text
                          model=".reponame"
                         // autoFocus
                          //required
                         // defaultValue={repo}
                         value={repo}
                         //initialState={''}
                         onBlur={checkexisting}
                          onChange={(e)=>setRepo(e.target.value)}
                        />
                          {/* {(repo === "" || repo === null) && <option value="">Please select project name</option>}
                          {props.customerprojectList.map(item => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Control.select> */}
                      </fieldset>
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="datafactory.type"
                            defaultMessage="Data Factory Type"
                          />
                        </label>
                       <Control.select
                              model=".type"
                              autoFocus
                              value={type}
                              onChange={(e)=>setType(e.target.value)}
                              required
                            >
                              <option value="">Please select data platform type</option>
                              <option value="spark">Spark</option>
                              <option value="databricks">Databricks</option>
                        
                            </Control.select>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="spark.version"
                            defaultMessage="Data Platform Version "
                          />
                        </label>
                        {type === "spark" ? (
                       <Control.select
                              model=".srclang"
                              autoFocus
                              value={srclang}
                              //onChange={(e)=>setTargetLanguage(e.target.value)}
                              onChange={(e)=>setSrclang(e.target.value)}
                              required
                            >                              
                              <option value="">Please select spark version</option>
                              <option value="2.3">2.3</option>
                              <option value="3.0">3.0</option>                           
                        </Control.select>):
                        (<Control.select
                              model=".srclang"
                              autoFocus
                              value={srclang}
                              onChange={(e)=>setSrclang(e.target.value)}
                              required
                            >                              
                              <option value="">Please select data platform version</option>
                              <option value="7.3 LTS">7.3 LTS</option>
                              <option value="9.1 LTS">9.1 LTS</option>
                              <option value="10.4 LTS">10.4 LTS</option>
                              <option value="11.3 LTS">11.3 LTS</option>
                              <option value="12.2 LTS">12.2 LTS</option>
                              <option value="13.3 LTS">13.3 LTS</option>
                        </Control.select>
                        )}
                      </fieldset>



                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="target.language"
                            defaultMessage="Target Language:"
                          />
                        </label>
                    {type === "spark" ? (
                        <Control.select
                          model=".tgtlang"
                          autoFocus
                          required
                          value={targetLanguage}//{stagingrepo}
                          onChange={(e) =>(setTargetLanguage(e.target.value)) }           //)setStagingrepo(e.target.value) }
                        >
                      
                              <option value="">Please select target language</option>
                              <option value="Python">Python</option>
                              <option value="Scala">Scala</option>
                        </Control.select>
                      ):(
                        <Control.select
                          model=".tgtlang"
                          autoFocus
                          required
                          value={targetLanguage}//{stagingrepo}
                          onChange={(e) =>(setTargetLanguage(e.target.value)) }           //)setStagingrepo(e.target.value) }
                        >
                        <option value="">Please select target language</option>
                              <option value="Python Notebook">Python Notebook</option>
                  
                        </Control.select>
                        )}
                      </fieldset>

                      {type === "spark" &&( <div>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="dev.test.env"
                            defaultMessage="Development Test Environment"
                          />
                        </label>



                        <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="hive.version"
                            defaultMessage="Hive Version"
                          />
                        </label>

                        <Control.select
                          model=".hive"
                          autoFocus
                          required
                          value={hive}
                        //  onChange={selectCus}
                          onChange={(e) =>(setHive(e.target.value))}
                        >

                             <option value="">Please select hive version</option>
                             <option value="1.2">1.2</option>

                        </Control.select>

                      </fieldset>


                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="hadoop.version"
                            defaultMessage="Hadoop Version: "
                          />
                        </label>

                        <Control.select
                          model=".hadoop"
                          autoFocus
                          required
                          value={hadoop}
                          onChange={(e) =>(setHadoop(e.target.value))}
                        >

                       <option value="">Please select underling Hadoop environment</option>
                             <option value="2.6">2.6</option>
                        </Control.select>

                      </fieldset>


                  <fieldset>
                    <div>
                      <label style={{ textTransform: 'capitalize' }}>
                                    <FormattedMessage
                                      id="data.source"
                                      defaultMessage="JDBC Data Source"
                                    />
                          
                        </label>
            
                       <p style={{ float: 'left',height:'35px',marginLeft:'300px',fontSize:'10px' }}>
                         <ModalExample hasTitle

                                        info
                                        infoText="SQL/No SQL Data source"
                                        className="modal_md"
                                        repos = {repos}
                                        changeStagingprj ={repoCallback}
                                        cleanback ={cleanback}
                                        buttonLabel = "Add new"
                                        setRepos = {setRepo}
                                        jdbcname = {jdbcname}
                                        setJdbcname={setJdbcname}
                                        jdbcdriver={jdbcdriver}
                                        setJdbcdriver={setJdbcdriver}
                                        dbversion={dbversion}
                                        setDbversion={setDbversion}
                                        port ={port}
                                        setPort ={setPort}
                                        dbname ={dbname}
                                        setDbname ={setDbname}
                                        dbusername ={dbusername}
                                        setDbusername ={setDbusername}
                                        dbpassword = {dbpassword}
                                        setDbpassword = {setDbpassword }
                                        dbpasswordconfirm = {dbpasswordconfirm}
                                        setDbpasswordconnfirm ={setDbpasswordconnfirm}
                                        jdbcdriverList={jdbcdriverList}
                                        //setJdbcdriverList={setJdbcdriverList}
                                        clickSubmitHandler = {props.clickSubmitHandler}
                                        LocalForm = {LocalForm}
                                        //setClick={click => props.openModal = click}
                                        //setClick={click => openModal}
                          >

                          </ModalExample>
                          </p>
                          <p style={{ float: 'left',height:'35px',marginLeft:'140px' }}>
                          <ModalExample4 hasTitle
                                        info
                                        infoText="SQL/NoSQL Data source"
                                        className="modal_md"
                                        repos = {repos}
                                        changeStagingprj ={repoCallbackEdit}
                                        buttonLabel = "Edit"
                                        setRepos = {setRepo}
                                        jdbcname = {jdbcname}
                                        setJdbcname={setJdbcname}
                                        port ={port}
                                        setPort ={setPort}
                                        dbname ={dbname}
                                        setDbname ={setDbname}
                                        dbusername ={dbusername}
                                        setDbusername ={setDbusername}
                                        dbpassword = {dbpassword}
                                        setDbpassword = {setDbpassword }
                                        dbpasswordconfirm = {dbpasswordconfirm}
                                        setDbpasswordconnfirm ={setDbpasswordconnfirm}
                                        jdbcdriver={jdbcdriver}
                                        setJdbcdriver={setJdbcdriver}
                                        dbversion={dbversion}
                                        setDbversion={setDbversion}
                                        clickSubmitHandler = {props.clickSubmitHandler}
                                        edit={edit}
                          >
                          </ModalExample4>
                      </p>
                      <p style={{ float: 'left',height:'35px',marginLeft:'30px',marginTop:'-30px' }}>
                        <button disabled={edit}
                            className="button"
                            // style={{ display: 'inline-block'}}
                            type="button"
                            //disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED' ||  this.state.jobStatus === 'In Progress' || this.state.stagingrepo ==''}
                            //onClick={this.submitRequest}
                            onClick={deleteJdbc}
                          >
                            <FormattedMessage
                              id="datasource.delete"
                              defaultMessage="Delete"
                            />
                          </button>
                      </p>    
                      </div>
                    </fieldset>
                 </div>
                 )}


                      <div className="button-container" style={{ textAlign: 'center' }}>
                      {jdbclistcopyy.length>0 && ( <UserTable style={{}} data={jdbclistcopyy} selectItem={selectItem}  username={props.username}/>
                      )}
                     {/* <UserTable style={{}} data={sessionjdbc} selectItem={selectItem}  username={props.username}/>  */}
                        <button
                          className="button"
                          style={{ marginRight: '40px' }}
                          type="button"
                          onClick={() => props.clickBackHandler()}
                        >
                          <FormattedMessage
                            id="run-assessment.back.button.name"
                            defaultMessage="Back"
                          />
                        </button>

                      {type === "spark" ? (
                          <button className="button" type="submit"
                          disabled={repo.trim()==""||srclang==""||targetLanguage==""||hive=="" ||hadoop==""}>
                          {/* onClick={submitRequest} */}
                            <FormattedMessage
                              id="submit.button.name"
                              defaultMessage="submit"
                            />
                          </button>):(
                            <button className="button" type="submit"
                          disabled={repo.trim()==""||srclang==""||targetLanguage==""}>
                          {/* onClick={submitRequest} */}
                            <FormattedMessage
                              id="submit.button.name"
                              defaultMessage="submit"
                            />
                          </button>
                          )}
                      </div>
                    </div>
                  </LocalForm>
                ) : null}
              </div>
            )}
 {/* <UserTable style={{}} data={props.usersList} selectItem={selectItem}  username={props.username}/> */}
            {showMessage && (
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%'
                  }}
                >
                  {/* Your Commercial Code Translation request has been submitted.  The Commercial Code reference ID is  {refId}.  You will be notified via email once the SHIFT Commercial Code Translation is generated. */}
                Data factory creation or update successfully.
                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div className="button-container" style={{ textAlign: 'center' }}>
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={props.clickBackHandler}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            )}



          </div>
        </div>
        <Footer />
      </div>
    );
  }
  else{
    return (
      <div className="preview page">
        <Helmet>
          Translation - SHIFT
        </Helmet>
        <Header
          title={messages.headerTitle}
          subtitle={messages.headerSubTitle}
          icon="preview"
          locale={props.locale}
          status = {props.status}
        />
        <ModalExample
          hasTitle
          confirmation
          infoText="Confirmation"
          className="modal_md"
          setClick={click => confirmation = click}
          confirmationSub = {confirmationSubmit}
          content={confirmationText}/>

        <div className="main">
          <div
            className="panel"
            style={{
              width: '90%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            {!showMessage && (
              <div>
                {showUpload ? (
                  <div className="form">
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="assessment.projectName"
                        defaultMessage="Project Name"
                      />
                    </label>
                    <Control.text
                      model=".projectName"
                      autoFocus
                      value={projectName}
                      placeholder={uploadType==='upload' ?"same as zip file name" : ""}
                      disabled
                    />
                    <br />
                    <br />
                    <br />
                    {MyUploader(projectName,props.username,uploadType,"translation","",props.customerid,
                      uploadcontent,setUploadcontent,_setDisableUploadBack,setPrjName,checkuploadinlist,disableUploadBack,
                      disableupload,setDisableupload
                    )}
                    <br />
                    <br />
                    <br />

                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={showUploadFalse}
                      disabled={disableUploadBack}
                    >
                      back
                    </button>
                  </div>
                ) : null}

                {showEditor ? (
                  <div>
                    <Container >
                      <Row>
                        <Col xs="6">
                          <label>Code</label>
                          <AceEditor
                            mode="java"
                            theme="github"
                            placeholder="Copy And Paster Your Source Code Here."
                            // height = "610px"
                            width = "400px"
                            // onChange={onChange}
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            maxLines = {20000}
                          />
                        </Col>

                        <Col xs="6">
                          <label>Result</label>
                          <AceEditor
                            mode="java"
                            theme="github"
                            // height = "610px"
                            width = "400px"
                            // onChange={onChange}
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            readOnly
                            value="SELECT column1, column2, ...
FROM table_name
WHERE condition;"
                          />
                        </Col>
                      </Row>
                    </Container>
                    <br/>
                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={()=>setShowEditor(false)}
                    >
                      back
                    </button>
                    <button
                      className="button"
                      type="button"
                      style={{ marginRight: '40px' }}
                      onClick={()=>setShowEditor(false)}
                    >
                      Translate
                    </button>
                  </div>
                ) : null}

                {!showEditor && !showUpload ? (
                  <div>
                    {!showFiles ? (
                      <LocalForm className="form">
                        <div
                          style={{
                            marginLeft: '3%'
                          }}
                        >
                          {/*  <i>*/}
                          {/*    <a*/}
                          {/*      // onClick={this.showUploadTrue}*/}
                          {/*      target="_blank"*/}
                          {/*      style={{*/}
                          {/*        color: 'rgb(68, 199, 244)',*/}
                          {/*        cursor: 'pointer',*/}
                          {/*        'textDecoration': 'underline'*/}
                          {/*      }}*/}
                          {/*    >*/}
                          {/*      Upload Source Code*/}
                          {/*    </a>*/}
                          {/*  </i>*/}
                          {/*  &nbsp;*/}
                          {/*  &nbsp;*/}
                          {/*  or*/}
                          {/*  &nbsp;*/}
                          {/*  &nbsp;*/}
                          {/*  <i>*/}
                          {/*    <a*/}
                          {/*      onClick={()=> setShowEditor(true)}*/}
                          {/*      target="_blank"*/}
                          {/*      style={{*/}
                          {/*        color: 'rgb(68, 199, 244)',*/}
                          {/*        cursor: 'pointer',*/}
                          {/*        'textDecoration': 'underline'*/}
                          {/*      }}*/}
                          {/*    >*/}
                          {/*      Copy And Paste Source Code For Translation*/}
                          {/*    </a>*/}
                          {/*  </i>*/}
                          {/*<br/>*/}
                          {/*<br/>*/}

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="source.code.project.name"
                                defaultMessage="Source Code Repository Name: "
                              />
                            </label>

                            <Control.select
                              model=".reponame"
                              required
                              value={repo}
                              onChange={changeRepo}
                            >
                              {(repo === "" || repo === null) && <option value="">Please select project name</option>}
                              {props.customerprojectList.map(item => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </Control.select>
                            <button
                              className="button asse_upload"
                              type="button"
                              onClick={()=>showUploadTrue("update")}
                              disabled={repo === ""}
                            >
                              Update source code
                            </button>
                          </fieldset>

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="projects.project.source-languagee"
                                defaultMessage="Source Language: "
                              />
                            </label>

                            <Control.select
                              model=".srclang"
                              autoFocus
                              value={srclang}
                              onChange={(e)=>setSrclang(e.target.value)}
                              required
                            >
                              {(srclang === "" || srclang === null) && <option value="">Please select source language</option>}
                              <option value="teradata">Teradata</option>
                            </Control.select>

                          </fieldset>

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="projects.project.target-language"
                                defaultMessage="Target Language: "
                              />
                            </label>

                            <Control.select
                              model=".tgtlang"
                              autoFocus
                              value={targetLanguage}
                              onChange={(e)=>setTargetLanguage(e.target.value)}
                              required
                            >
                              {(targetLanguage === "" || targetLanguage === null) && <option value="">Please select target language</option>}
                              <option value="FUSE">FUSE</option>
                            </Control.select>
                          </fieldset>

                          <fieldset>
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="comments.name"
                                defaultMessage="Description"
                              />
                            </label>
                            <Control.text
                              model=".description"
                              value={description}
                              onChange={e => setDescription(e.target.value)}
                            />
                          </fieldset>

                          <div className="button-container" style={{ textAlign: 'center' }}>
                            <button
                              className="button"
                              style={{ marginRight: '40px' }}
                              type="button"
                              onClick={() => props.clickBackHandler()}
                            >
                              <FormattedMessage
                                id="run-assessment.back.button.name"
                                defaultMessage="Back"
                              />
                            </button>



                            <button
                              className="button"
                              type="button"
                              style={{ marginRight: '40px' }}
                              onClick={()=>showUploadTrue("upload")}
                            >
                              Upload source code
                            </button>

                            <button
                              className="button"
                              type="submit"
                              onClick={gotoFileList}
                            >
                              <FormattedMessage
                                id="onboard.next"
                                defaultMessage="next"
                              />
                            </button>
                          </div>
                        </div>
                      </LocalForm>
                    ) : null}

                    {showFiles && (
                      <div className="form">
                        <label
                          style={{
                            width: '90%',
                            fontSize: '16px',
                            textTransform: 'none',
                            lineHeight: '150%',
                            textAlign: 'center'
                          }}
                        >
                          Here is a list of files in your project. Please review before you click the Submit button.
                        </label>
                        <FilesTable
                          data={props.filesList}
                          deleteUser={props.deleteUser}
                          username={props.username}>
                        </FilesTable>

                        <div
                          className="button-container"
                          style={{ textAlign: 'center' }}
                        >
                          <button
                            className="button"
                            type="button"
                            style={{ marginRight: '40px' }}
                            onClick={() => setShowFiles(false)}
                          >
                            <FormattedMessage
                              id="run-assessment.back.button.name"
                              defaultMessage="Back"
                            />
                          </button>

                          <button
                            className="button"
                            type="button"
                            onClick={submitRequest}
                          >
                            <FormattedMessage
                              id="submit.button.name"
                              defaultMessage="Submit"
                            />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
            )}

            {showMessage && (
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%'
                  }}
                >
                  Your Commercial Code Translation request has been submitted for review and will be sent to your Administrator for approval.
                  Your Commercial Code reference ID is  {refId}.  You will be notified via email when your request is approved.

                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div className="button-container" style={{ textAlign: 'center' }}>
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={props.clickBackHandler}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
        <Footer />
      </div>
    );
  }

};

export default Createdatafactory;



// WEBPACK FOOTER //
// ./src/components/views/Createdatafactory/index.js